import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import { formatEnv, formatService } from "./formatters";
import { LogEntry } from "./types";
import { tokens, SEVERITY, severityForLevel, levelLabel } from "./tokens";
import LogDetailContent from "./LogDetailContent";

interface LogDetailDrawerProps {
  log: LogEntry | null;
  onClose: () => void;
}

export default function LogDetailDrawer({ log, onClose }: LogDetailDrawerProps) {
  if (!log) return null;

  const sev = SEVERITY[severityForLevel(log.level)];

  return (
    <Drawer
      anchor="right"
      open={!!log}
      onClose={onClose}
      slotProps={{ paper: { sx: { width: { xs: "100%", sm: 440 }, bgcolor: tokens.surface } } }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            borderBottom: `1px solid ${tokens.divider}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Chip
              label={levelLabel(log.level)}
              size="small"
              sx={{ bgcolor: sev.bg, color: sev.text, fontWeight: 700 }}
            />
            <Chip
              label={formatService(log.service)}
              size="small"
              variant="outlined"
              sx={{ borderColor: tokens.divider, color: tokens.textSecondary }}
            />
            {log.environment && (
              <Chip
                label={formatEnv(log.environment)}
                size="small"
                variant="outlined"
                sx={{ borderColor: tokens.divider, color: tokens.textSecondary }}
              />
            )}
            {log.supplier && (
              <Chip
                label={log.supplier}
                size="small"
                variant="outlined"
                sx={{ borderColor: tokens.divider, color: tokens.textSecondary, textTransform: "capitalize" }}
              />
            )}
          </Stack>
          <IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, overflow: "auto", px: 2.5, py: 2 }}>
          <LogDetailContent log={log} />
        </Box>
      </Box>
    </Drawer>
  );
}
